import React, { useState } from "react";
import PropTypes from "prop-types";
import { useOktaAuth } from "@okta/okta-react";
import Cookies from "./helpers/Cookies";
import Constants from "./common/Constants";
import ProgressOverlay from "./components/shared/ProgressOverlay";

// Basic component with logout button
const OktaLogout = ({ resetSession = () => {} }) => {
  const { oktaAuth, authState } = useOktaAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [logoffMsg, setLogoffMsg] = useState(<></>);
  const revokeToken = async (e) => {
    e.preventDefault();
    try {
      // Explicitly revoke the access token
      if (authState.accessToken) {
        await oktaAuth.revokeAccessToken(authState.accessToken);
      }

      // Close the Okta session
      const closeSession = await oktaAuth.closeSession();
      console.log("Okta session closed:", closeSession);

      // Signout from the application
      await oktaAuth.signOut({
        accessToken: authState.accessToken,
        idToken: authState.idToken,
        postLogoutRedirectUri: `${window.location.origin}/#/logout`,
        clearTokensBeforeRedirect: true
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  const logout = async (e) => {
    setIsLoggingOut(true);
    const msg = <>Please wait, signing out..</>;
    setLogoffMsg(msg);

    // Reset session state
    resetSession();

    // Delete the custom cookies
    Cookies.setCookie(Constants.DENTSU_COOKIE, "", null, true);
    Cookies.setCookie(Constants.APP_LOGIN_KEY, "", null, true);
    Cookies.setCookie(Constants.APP_LOGIN_KEY_APPEND, "", null, true);
    Cookies.setCookie(Constants.APP_LOGIN_USER, "", null, true);

    // Clear localStorage in case there is any
    localStorage.clear();
    // Revoke tokens and sessions
    setIsLoggingOut(false);
    setLogoffMsg(<></>);
    await revokeToken(e);
  };
  return (
    <>
      <a
        onClick={logout}
        alt="Logout User"
        className="nav-logout"
        href=" "
        title="Logout"
      >
        <i className="fas fa-power-off" />
        {`  `}
        Logout
      </a>
      {isLoggingOut && <ProgressOverlay message={logoffMsg} />}
    </>
  );
};

OktaLogout.propTypes = {
  resetSession: PropTypes.func
};

export default OktaLogout;
